(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const cartCountEls = () => $$("[data-cart-count]");

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "es-ES", {
        style: "currency",
        currency: currency || window.Shopify?.currency?.active || "EUR",
      }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2) + " €";
    }
  }

  async function getCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  function setCartCount(count) {
    cartCountEls().forEach((el) => {
      el.textContent = String(count);
      el.hidden = count < 1;
    });
  }

  function lineHtml(item) {
    const img = item.image
      ? item.image.replace(/(\.[^.]*)$/, "_200x$1")
      : "";
    return `<article class="cart-item" data-key="${item.key}">
      <a href="${item.url}">${img ? `<img src="${img}" alt="">` : ""}</a>
      <div>
        <a class="product-card__title" href="${item.url}">${item.product_title}</a>
        <p class="product-card__price">${money(item.final_line_price)}</p>
        <button type="button" class="nav-link" data-remove="${item.key}">Remove</button>
      </div>
      <div>${item.quantity}</div>
    </article>`;
  }

  function renderDrawer(cart) {
    const drawer = $("[data-cart-drawer]");
    if (!drawer) return;
    const items = $("[data-cart-items]", drawer);
    const total = $("[data-cart-total]", drawer);
    const empty = $("[data-cart-empty]", drawer);
    if (!cart.items.length) {
      items.innerHTML = "";
      if (empty) empty.hidden = false;
    } else {
      if (empty) empty.hidden = true;
      items.innerHTML = cart.items.map(lineHtml).join("");
    }
    if (total) total.textContent = money(cart.total_price, cart.currency);
    setCartCount(cart.item_count);
  }

  function openDrawer() {
    const drawer = $("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.add("is-open");
    document.body.classList.add("drawer-open");
  }

  function closeDrawer() {
    const drawer = $("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.classList.remove("drawer-open");
  }

  async function addToCart(id, quantity = 1) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id, quantity }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || "Could not add to cart");
    }
    const cart = await getCart();
    renderDrawer(cart);
    openDrawer();
    return cart;
  }

  async function removeLine(key) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    renderDrawer(await getCart());
  }

  document.addEventListener("click", (e) => {
    const add = e.target.closest("[data-add-to-cart]");
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      const id = add.getAttribute("data-add-to-cart");
      addToCart(id).catch((err) => alert(err.message));
    }

    if (e.target.closest("[data-open-cart]")) {
      e.preventDefault();
      getCart().then(renderDrawer).then(openDrawer);
    }
    if (e.target.closest("[data-close-cart]")) {
      e.preventDefault();
      closeDrawer();
    }
    const remove = e.target.closest("[data-remove]");
    if (remove) {
      e.preventDefault();
      removeLine(remove.getAttribute("data-remove"));
    }

    if (e.target.closest("[data-open-menu]")) {
      $("[data-mobile-nav]")?.classList.add("is-open");
      document.body.classList.add("drawer-open");
    }
    if (e.target.closest("[data-close-menu]")) {
      $("[data-mobile-nav]")?.classList.remove("is-open");
      document.body.classList.remove("drawer-open");
    }

    if (e.target.closest("[data-open-search]")) {
      e.preventDefault();
      $("[data-search-modal]")?.classList.add("is-open");
      $("[data-search-input]")?.focus();
    }
    if (e.target.closest("[data-close-search]")) {
      $("[data-search-modal]")?.classList.remove("is-open");
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeDrawer();
      $("[data-mobile-nav]")?.classList.remove("is-open");
      $("[data-search-modal]")?.classList.remove("is-open");
      document.body.classList.remove("drawer-open");
    }
  });

  const searchInput = $("[data-search-input]");
  const searchResults = $("[data-search-results]");
  let searchTimer;
  searchInput?.addEventListener("input", () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    searchTimer = setTimeout(async () => {
      if (q.length < 2) {
        if (searchResults) searchResults.innerHTML = "";
        return;
      }
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`
      );
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      if (!searchResults) return;
      searchResults.innerHTML = products
        .map(
          (p) => `<a href="${p.url}">
            ${p.image ? `<img src="${p.image}" alt="">` : "<span></span>"}
            <span>
              <strong class="font-display">${p.title}</strong><br>
              <span class="product-card__price">${p.price}</span>
            </span>
          </a>`
        )
        .join("");
    }, 180);
  });

  $$("[data-gallery]").forEach((gallery) => {
    const stage = $("[data-gallery-stage]", gallery);
    $$("[data-gallery-thumb]", gallery).forEach((btn) => {
      btn.addEventListener("click", () => {
        $$("[data-gallery-thumb]", gallery).forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        const src = btn.getAttribute("data-src");
        const srcset = btn.getAttribute("data-srcset");
        if (stage) {
          stage.src = src;
          if (srcset) stage.srcset = srcset;
        }
      });
    });
  });

  document.addEventListener("submit", (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const submit = form.querySelector('[type="submit"][name="add"], [type="submit"]');
    if (submit) submit.disabled = true;
    fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
      .then(async (res) => {
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || "Could not add to cart");
        }
        return getCart();
      })
      .then((cart) => {
        renderDrawer(cart);
        openDrawer();
      })
      .catch((err) => alert(err.message))
      .finally(() => {
        if (submit) submit.disabled = false;
      });
  });

})();
